export default "__VITE_ASSET__DqSAqUpz__"